var _circle, _circle2, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgExpandIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 24,
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 11.5,
  r: 10.5,
  fill: "black"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 12.5,
  cy: 12,
  r: 12,
  fill: "black"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 5,
  y: 5,
  width: 15,
  height: 14
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14.5181 15.2605C13.5827 15.946 12.426 16.3458 11.1765 16.3458C8.04192 16.3458 5.5 13.8039 5.5 10.6693C5.5 7.53478 8.04192 5 11.1765 5C14.311 5 16.853 7.53478 16.853 10.6693C16.853 11.9046 16.4602 13.0399 15.7962 13.9681C17.1314 15.1748 19.1878 17.0955 19.4234 17.7239C19.8162 18.7735 18.588 19.1376 18.231 18.9234C17.824 18.6807 15.7962 16.5957 14.5181 15.2605ZM11.1765 15.1534C13.647 15.1534 15.6534 13.147 15.6534 10.6693C15.6534 8.19882 13.647 6.19242 11.1765 6.19242C8.69882 6.19242 6.69242 8.19882 6.69242 10.6693C6.69242 13.147 8.69882 15.1534 11.1765 15.1534Z",
  fill: "white"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.5181 15.2605C13.5827 15.946 12.426 16.3458 11.1765 16.3458C8.04192 16.3458 5.5 13.8039 5.5 10.6693C5.5 7.53478 8.04192 5 11.1765 5C14.311 5 16.853 7.53478 16.853 10.6693C16.853 11.9046 16.4602 13.0399 15.7962 13.9681C17.1314 15.1748 19.1878 17.0955 19.4234 17.7239C19.8162 18.7735 18.588 19.1376 18.231 18.9234C17.824 18.6807 15.7962 16.5957 14.5181 15.2605ZM11.1765 15.1534C13.647 15.1534 15.6534 13.147 15.6534 10.6693C15.6534 8.19882 13.647 6.19242 11.1765 6.19242C8.69882 6.19242 6.69242 8.19882 6.69242 10.6693C6.69242 13.147 8.69882 15.1534 11.1765 15.1534Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.2083 3.37305H4.07178V20.5096H21.2083V3.37305Z",
  fill: "white"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgExpandIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/expand-icon.90c1c0ac0b99496bafa718fc36cb8be9.svg";